<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormConceptoFYM" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="CodigoSat">Código SAT</label>
							<input type="text" v-model="objConceptoFYM.CodigoSat" class="form-control" id="Codigo SAT" placeholder="Ingresar CodigoSat" />
							<CValidation v-if="this.errorvalidacion.CodigoSat" :Mensaje="'*'+errorvalidacion.CodigoSat[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Tipo">Tipo</label>
                            <select v-model="objConceptoFYM.Tipo" id="Tipo" class="form-control form-select">
                                <option value="">Seleccione una opción</option>
                                <option value="F">Floreria</option>
                                <option value="M">Montaje</option>
                            </select>
							<CValidation v-if="this.errorvalidacion.Tipo" :Mensaje="'*'+errorvalidacion.Tipo[0]"/>
						</div>
					</div>
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormConceptoFYM',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objConceptoFYM: {
				IdConceptoFYM: 0,
				CodigoSat: '',
				Tipo: '',
				IdEmpresa: 0,
				IdSucursal: 0,
            },

            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objConceptoFYM.IdConceptoFYM == 0) {
				await this.$http.post(
					'conceptosFYM',this.objConceptoFYM
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'conceptosFYM/'+this.objConceptoFYM.IdConceptoFYM,
					this.objConceptoFYM
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "conceptosFYM/"+this.objConceptoFYM.IdConceptoFYM
            ).then((res) => {
                this.objConceptoFYM = res.data.data;

            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objConceptoFYM = {
				IdConceptoFYM: 0,
				CodigoSat: '',
				Tipo: '',
				IdEmpresa: 0,
				IdSucursal: 0,
				
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objConceptoFYM.IdConceptoFYM = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
